import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9cfaa95a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "weather-card-ct"
}
const _hoisted_2 = { class: "temp-ct" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "temp" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-normal" }, "C", -1))
const _hoisted_6 = { class: "weather-description" }
const _hoisted_7 = { class: "other-data" }
const _hoisted_8 = { class: "align-middle" }
const _hoisted_9 = { class: "wind_dir" }

import { Weather } from '@/typings/services/weather';


export default /*#__PURE__*/_defineComponent({
  __name: 'WeatherCard',
  props: {
    location: null,
    weather: null
  },
  setup(__props: any) {

const props = __props as { location: [number, number]; weather: Weather }



return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (__props.weather)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "weather_icon_img",
            src: `http://openweathermap.org/img/wn/${__props.weather.weather[0].icon}.png`
          }, null, 8, _hoisted_3),
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode(_toDisplayString(__props.weather.main.temp.toFixed(1)) + "°", 1),
            _hoisted_5
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(__props.weather.name) + " (" + _toDisplayString(__props.weather.weather[0].description) + ")", 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", null, "Clouds: " + _toDisplayString(__props.weather.clouds.all) + "%", 1),
          _createElementVNode("p", null, "Visibility: " + _toDisplayString(__props.weather.visibility / 1000) + " Km", 1),
          _createElementVNode("p", _hoisted_8, [
            _createTextVNode(" Wind: "),
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_Icon, {
                icon: "mdi:arrow-up-thin",
                class: "wind_dir_icon",
                inline: true,
                style: _normalizeStyle({ transform: `rotateZ(${__props.weather.wind.deg}deg)` })
              }, null, 8, ["style"]),
              _createTextVNode(" " + _toDisplayString(__props.weather.wind.speed) + " m/s ", 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})